import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { SECURITY_PROFILE_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import Content from '../../../layout/Content';
import { clearSecurityProfile, getSecurityProfile, putSecurityProfile } from '../../../../actions/security/SecurityProfile';
import SecurityProfileForm from './SecurityProfileForm';
import { SECURITY_VISIBILITY } from '../../../../config/constants';

const EditSecurityProfile = ({
  breadcrumbs,
  securityProfile,
  match: {
    params: { id },
  },
  loading,
  dispatchClearSecurityProfile,
  dispatchPutSecurityProfile,
  dispatchGetSecurityProfile
}) => {

  useLayoutEffect(() => {
    dispatchGetSecurityProfile({ id })
    return () => dispatchClearSecurityProfile();
  }, []);

  const onSubmit = (formValues) => {
    const securityProfileJS = securityProfile.toJS();
    const newFormValues = { ...formValues };

    newFormValues.securityVisibility = formValues.securityVisibility.value;

    const formViewIds = formValues.viewAuthorizationList || [];
    const updatedViewAuthorizationList = formViewIds.map((item) => {
      const view = securityProfileJS.viewAuthorizationList.find((old) => old.viewId === item.value);
      return view ? view : { viewId: item.value, securityProfileId: id };
    });
    newFormValues.viewAuthorizationList = updatedViewAuthorizationList;

    const formEndpointIds = formValues.authorizedEndpointList || [];
    const updatedAuthorizedEndpointList = formEndpointIds.map((item) => {
      const endpoint = securityProfileJS.authorizedEndpointList.find((old) => old.endpointId === item.value);
      return endpoint ? endpoint : { endpointId: item.value, securityProfileId: id };
    });
    newFormValues.authorizedEndpointList = updatedAuthorizedEndpointList;

    dispatchPutSecurityProfile(id, newFormValues);
  }

  let content;

  if (loading) {
    content = <Loader />;
  } else if (securityProfile.isEmpty()) {
    content = <NoDataResource returnPage={SECURITY_PROFILE_PATH} />;
  } else {
    const securityProfileJS = securityProfile.toJS();

    const initialValues = {
      name: securityProfileJS.name,
      description: securityProfileJS.description,
      viewAuthorizationList: securityProfileJS.viewAuthorizationList.map(({ view }) => ({
        label: view.name,
        value: view.id,
      })),
      authorizedEndpointList: securityProfileJS.authorizedEndpointList.map(({ endpoint }) => ({
        label: endpoint.name,
        value: endpoint.id,
      })),
      securityVisibility: {
        value: securityProfileJS.securityVisibility,
        label:
          SECURITY_VISIBILITY[securityProfileJS.securityVisibility].label,
      }
    }

    content = (
      <SecurityProfileForm onSubmit={onSubmit} initialValues={initialValues} />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Perfil de Seguridad"
      subtitle="Editar Perfil de Seguridad"
      content={content}
    />
  );
}


EditSecurityProfile.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetSecurityProfile: PropTypes.func.isRequired,
  dispatchClearSecurityProfile: PropTypes.func.isRequired,
  dispatchPutSecurityProfile: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  securityProfile: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditSecurityProfile.defaultProps = {
  loading: false,
};

const mapStateToProps = (
  { SecurityUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...SecurityUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Perfiles de Seguridad',
      href: SECURITY_PROFILE_PATH,
    },
    {
      text: 'Ver',
      href: `${SECURITY_PROFILE_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  securityProfile: SecurityUnit.SecurityProfile.getIn(['current', 'content']),
  loading: !SecurityUnit.SecurityProfile.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetSecurityProfile: getSecurityProfile,
  dispatchClearSecurityProfile: clearSecurityProfile,
  dispatchPutSecurityProfile: putSecurityProfile,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditSecurityProfile);
